import React, { useContext, useState, useEffect } from 'react';
import { auth } from '../firebase-config';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendPasswordResetEmail, updateEmail, updatePassword/*, EmailAuthProvider, reauthenticateWithCredential*/ } from 'firebase/auth';

import { db } from '../firebase-config';
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';

const AuthContext = React.createContext();

export function useAuth(){
    return useContext(AuthContext);
}

export function AuthProvider( { children }) {
    const [currentUser, setCurrentUser] = useState();
    const [currentUserInfo, setCurrentUserInfo] = useState();
    const [loading, setLoading] = useState(true);
    const [showSpinner, setShowSpinner] = useState(false);

    function login(email, password){
        return signInWithEmailAndPassword(auth, email, password).then((userCredential)=>{
            return true;
        }).catch((error)=>{
            return error.message;
        });
    }

    function signup(email, password, client = false){
        return createUserWithEmailAndPassword(auth, email, password).then((userCredential)=>{
            const user = userCredential.user;
            if(client === false){
                return setDoc(doc(db, "technicians", user.uid), {
                    email: user.email,
                    access: "none",
                    status: "revoked",
                    tech_name: `${user.email.split("@")[0]}`,
                    work_orders: [],
                }).then(()=>{
                    return true;
                }).catch((error)=>{
                    return error;
                });
            } else {
                return setDoc(doc(db, "clients", user.uid), {
                    email: user.email,
                    access: "none",
                    status: "revoked",
                    client_name: `${user.email.split("@")[0]}`,
                    work_orders: [],
                    links: [],
                }).then(()=>{
                    return true;
                }).catch((error)=>{
                    return error;
                });
            }
        }).catch((error)=>{
            const errorMessage = error.message;
            console.log("Error signing up: " + errorMessage)
            return errorMessage;
        });
    }

    function logout(){
        setCurrentUserInfo({});
        return signOut(auth);
    }

    function resetPassword(email){
        return sendPasswordResetEmail(auth, email);
    }

    function updateUserEmail(email){
        return updateEmail(currentUser, email);
    }

    function updateUserPassword(password){
        return updatePassword(currentUser, password);

        /*
        https://stackoverflow.com/questions/37811684/how-to-create-credential-object-needed-by-firebase-web-user-reauthenticatewith
        import {
            EmailAuthProvider,
            getAuth,
            reauthenticateWithCredential,
        } from 'firebase/auth'

        const auth = getAuth()
        const credential = EmailAuthProvider.credential(
            auth.currentUser.email,
            userProvidedPassword
        )
        const result = await reauthenticateWithCredential(
            auth.currentUser, 
            credential
        )   
        */
    }

    function updateCurrentUserInfo(newUserInfo){
        return setCurrentUserInfo(newUserInfo);
    }

    // update email, update password with PromiseAll https://www.youtube.com/watch?v=PKwu15ldZ7k 52:30

    useEffect(()=>{
        const unsubscribe = auth.onAuthStateChanged(user =>{
            setCurrentUser(user);
            if(user){
                user.getIdTokenResult().then((idTokenResult)=>{
                    user.admin = idTokenResult.claims.admin;
                    user.client = idTokenResult.claims.client;
                });
                const docRef = doc(db, 'technicians', user.uid);
                const clientRef = doc(db, 'clients', user.uid);
                getDoc(docRef).then((docSnap)=>{
                    if(docSnap.exists()){
                        setCurrentUserInfo({
                            email: docSnap.data().email,
                            access: docSnap.data().access,
                            tech_name: docSnap.data().tech_name,
                            status: docSnap.data().status,
                            work_orders: docSnap.data().work_orders,
                        });
                    }else{
                        // getDoc(clientRef).then((docSnap)=>{
                        //     if(docSnap.exists()){
                        //         setCurrentUserInfo({
                        //             email: docSnap.data().email,
                        //             access: docSnap.data().access,
                        //             client_name: docSnap.data().client_name,
                        //             status: docSnap.data().status,
                        //             work_orders: docSnap.data().work_orders,
                        //             links: docSnap.data().links
                        //         });
                        //     }else{
                        //         setCurrentUserInfo({});
                        //     }
                        // }).catch((error)=>{
                        //     setCurrentUserInfo({});
                        // });
                        const unsubsribeClient = onSnapshot(clientRef, (docSnap)=>{
                            // console.log('clientRef subscribe')
                            if(docSnap.exists()){
                                setCurrentUserInfo({
                                    email: docSnap.data().email,
                                    access: docSnap.data().access,
                                    client_name: docSnap.data().client_name,
                                    status: docSnap.data().status,
                                    work_orders: docSnap.data().work_orders,
                                    links: docSnap.data().links
                                });
                            }else{
                                setCurrentUserInfo({});
                            }
                        },(error)=>{
                            setCurrentUserInfo({});
                        });
                        return ()=>{
                            // console.log("unsubscribe from Auth ClientRef");
                            unsubsribeClient();
                        }
                    }
                }).catch((error)=>{
                    console.log(error);
                    setCurrentUserInfo({});
                });
            }else{
                console.log('user logged out')
                setCurrentUserInfo({});
            }
            setLoading(false);
        });

        return () => {
            // console.log("unsubscribe from Auth onAuthChanged event");
            unsubscribe();
        }
    }, []);

    const value = {
        currentUser,
        currentUserInfo,
        updateUserEmail,
        updateUserPassword,
        updateCurrentUserInfo,
        login,
        signup,
        logout,
        resetPassword,
        showSpinner,
        setShowSpinner,
    }
    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}
